import axios from 'axios'

import { base64ToBlob } from '@/helpers/base64ToBlob.helper'
import { getBase64Content } from '@/helpers/getBase64Content.helper'

export const uploadToS3 = async (base64Image: string, presignedUrl: string) => {
  try {
    const base64Content = getBase64Content(base64Image)
    const mimeType = base64Image.split(';')[0].split(':')[1]
    const blob = base64ToBlob(base64Content, mimeType)

    return await axios.put(presignedUrl, blob, {
      headers: {
        'Content-Type': mimeType,
      },
      withCredentials: false,
    })
  } catch {
    return false
  }
}
